// LIBRARIES
import styled from "styled-components";

//MISC;

export const HomePageContainer = styled.div`
  width: 100%;
  height: 100%;
`;
